import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as appState from '@smarsh-cyber/app-state';
import { WindowsService } from '../../shared/services';
import { isAuthenticated } from '../../shared/utils';
import { AuthComponentStore } from './auth-component.state';

@Injectable({
  providedIn: 'root'
})
export class AuthFacadeService extends AuthComponentStore {
  #store = inject(Store);

  userDetails$ = this.#store.selectSignal(appState.selectUser);
  userToken$ = this.#store.selectSignal(appState.selectUserToken);
  selectAppState$ = this.#store.selectSignal(appState.getCurrentRouteState);
  #appFacade = inject(appState.AppFacadeService);

  windowService = inject(WindowsService);
  #router = inject(Router);

  //DO not use this method outside action
  initLogoutAndRedirect(
    portalName: string,
    portalUrl: string,
    rediretAfterLogout = true
  ) {
    if (this.#appFacade.tokenRefreshInterval) {
      clearInterval(this.#appFacade.tokenRefreshInterval);
      this.#appFacade.tokenRefreshInterval = null;
    }
    this.authService.logoutAndRedirect(
      portalName,
      portalUrl,
      rediretAfterLogout
    );
  }

  navigateIfLoggedIn() {
    if (isAuthenticated(this.userToken$().portalName)) {
      this.#appFacade.init(
        this.userToken$().portalName,
        null,
        this.userToken$().portalUrl
      );
    } else {
      return;
      // this.#appFacade.logout();
    }
  }
}
